import { gql } from '@apollo/client';

export const CREATE_STANDARDIZED_ADDRESS_FROM_API = gql`
  mutation CreateStandardizedAddressFromApi($source: AddressApiSource!, $rawJson: String!) {
    createStandardizedAddressFromApi(source: $source, rawJson: $rawJson) {
      success
      addressId
      errorMessage
    }
  }
`;

export type AddressApiSource = 'SMARTY' | 'GOOGLE';

export interface CreateStandardizedAddressFromApiResponse {
  createStandardizedAddressFromApi: {
    success: boolean;
    addressId: string | null;
    errorMessage: string | null;
  };
}

export interface CreateStandardizedAddressFromApiVariables {
  source: AddressApiSource;
  rawJson: string;
}
